import { render, staticRenderFns } from "./payLang.vue?vue&type=template&id=75561e03&"
import script from "./payLang.vue?vue&type=script&lang=js&"
export * from "./payLang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75561e03')) {
      api.createRecord('75561e03', component.options)
    } else {
      api.reload('75561e03', component.options)
    }
    module.hot.accept("./payLang.vue?vue&type=template&id=75561e03&", function () {
      api.rerender('75561e03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/payLang.vue"
export default component.exports